enum IUploadTabEnum {
  DROPBOX,
  DROPBOXSEARCH,
  LOCAL,
  PROJECT,
}

export default IUploadTabEnum;
